module.exports = __webpack_public_path__ + "img/ayun-ab-and-qb-comparison.c0c86c1c.png";